module.exports = __webpack_public_path__ + "img/hewlett-packard.9fa89d17.svg";